<router-outlet *ngIf="!isIframe"></router-outlet>
<ngx-spinner type="square-jelly-box" size="medium"></ngx-spinner>
